module.exports = __webpack_public_path__ + "img/customerCase1.84754be9.jpg";